import { PlanType } from "@/features/stripe/types/stripe-plan";

import { useAuth } from "./use-auth";

export type SubscriptionStatus = PlanType;

const planLevels: Record<PlanType, number> = {
  Free: 0,
  "Beginning Monthly": 1,
  "Beginning Yearly": 1,
  "Basic Monthly": 2,
  "Basic Yearly": 2,
  "Premium Monthly": 3,
  "Premium Yearly": 3,
};

export const usePermission = (requiredStatus: PlanType): boolean => {
  const { profile } = useAuth();
  const currentPlan = profile?.plan ?? "Free";
  return planLevels[currentPlan] >= planLevels[requiredStatus];
};
